import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navBar">
      <ol>
        <li>
          <a href="#About">About</a>
          {/* <Link to="/about">About</Link> */}
        </li>
        <li>
          <a href="#Skills">Skills</a>
          {/* <Link to="/skill">Skills</Link> */}
        </li>
        <li>
          <a href="#Project">Projects</a>
          {/* <Link to="/project">Projects</Link> */}
        </li>
        <li>
          <a href="#Contact">Contact</a>
          {/* <Link to="/contact">Contact</Link> */}
        </li>
        {/* <li>
          <Link to="/blog">Blog</Link>
        </li> */}
      </ol>
      <button className="resume__button">
        <a href="https://drive.google.com/file/d/1uklG_5qf_7ip5n5G1dYVhwAauHjUxtVJ/view">
          Resume
        </a>
      </button>
    </div>
  );
};

export default Navbar;
